// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AdvancedSearchController from "./advanced_search_controller"
application.register("advanced-search", AdvancedSearchController)

import AutoclickController from "./autoclick_controller"
application.register("autoclick", AutoclickController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import BooleanInputController from "./boolean_input_controller"
application.register("boolean-input", BooleanInputController)

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import Charts__FeedHistogramController from "./charts/feed_histogram_controller"
application.register("charts--feed-histogram", Charts__FeedHistogramController)

import Charts__PartiesPieChartController from "./charts/parties_pie_chart_controller"
application.register("charts--parties-pie-chart", Charts__PartiesPieChartController)

import Charts__PartiesTreemapChartController from "./charts/parties_treemap_chart_controller"
application.register("charts--parties-treemap-chart", Charts__PartiesTreemapChartController)

import Charts__StakeholdersChartController from "./charts/stakeholders_chart_controller"
application.register("charts--stakeholders-chart", Charts__StakeholdersChartController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ClearFormController from "./clear_form_controller"
application.register("clear-form", ClearFormController)

import ClearPostDraftController from "./clear_post_draft_controller"
application.register("clear-post-draft", ClearPostDraftController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColcadeController from "./colcade_controller"
application.register("colcade", ColcadeController)

import CollapsibleTabsController from "./collapsible_tabs_controller"
application.register("collapsible-tabs", CollapsibleTabsController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import DeselectableRadioButtonsController from "./deselectable_radio_buttons_controller"
application.register("deselectable-radio-buttons", DeselectableRadioButtonsController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import DocumentSearchController from "./document_search_controller"
application.register("document-search", DocumentSearchController)

import DropdownCardController from "./dropdown_card_controller"
application.register("dropdown-card", DropdownCardController)

import DuplicateCheckerController from "./duplicate_checker_controller"
application.register("duplicate-checker", DuplicateCheckerController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import EmailIframeController from "./email_iframe_controller"
application.register("email-iframe", EmailIframeController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import EmulationController from "./emulation_controller"
application.register("emulation", EmulationController)

import FaviconController from "./favicon_controller"
application.register("favicon", FaviconController)

import FeedNameSuggestionController from "./feed_name_suggestion_controller"
application.register("feed-name-suggestion", FeedNameSuggestionController)

import FeedPreviewController from "./feed_preview_controller"
application.register("feed-preview", FeedPreviewController)

import FeedReportExportController from "./feed_report_export_controller"
application.register("feed-report-export", FeedReportExportController)

import FieldManagerController from "./field_manager_controller"
application.register("field-manager", FieldManagerController)

import FieldsetManagerController from "./fieldset_manager_controller"
application.register("fieldset-manager", FieldsetManagerController)

import FilenameSanitizeController from "./filename_sanitize_controller"
application.register("filename-sanitize", FilenameSanitizeController)

import FilterPillSpinnerController from "./filter_pill_spinner_controller"
application.register("filter-pill-spinner", FilterPillSpinnerController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormRevealController from "./form_reveal_controller"
application.register("form-reveal", FormRevealController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import HtmlToImageController from "./html_to_image_controller"
application.register("html-to-image", HtmlToImageController)

import ImageGalleryController from "./image_gallery_controller"
application.register("image-gallery", ImageGalleryController)

import ImporterController from "./importer_controller"
application.register("importer", ImporterController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import InlineModalController from "./inline_modal_controller"
application.register("inline-modal", InlineModalController)

import InlineModalTriggerController from "./inline_modal_trigger_controller"
application.register("inline-modal-trigger", InlineModalTriggerController)

import KeywordHighlightsController from "./keyword_highlights_controller"
application.register("keyword-highlights", KeywordHighlightsController)

import KeywordsFormController from "./keywords_form_controller"
application.register("keywords-form", KeywordsFormController)

import KeywordsImpactController from "./keywords_impact_controller"
application.register("keywords-impact", KeywordsImpactController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ListController from "./list_controller"
application.register("list", ListController)

import MagicGenerateController from "./magic_generate_controller"
application.register("magic-generate", MagicGenerateController)

import MailMergeSortableController from "./mail_merge_sortable_controller"
application.register("mail-merge-sortable", MailMergeSortableController)

import UserMentionsController from "./user_mentions_controller"
application.register("user-mentions", UserMentionsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NameFieldsController from "./name_fields_controller"
application.register("name-fields", NameFieldsController)

import NavSearchController from "./nav_search_controller"
application.register("nav-search", NavSearchController)

import NavSearchLauncherController from "./nav_search_launcher_controller"
application.register("nav-search-launcher", NavSearchLauncherController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OpenReplayController from "./open_replay_controller"
application.register("open-replay", OpenReplayController)

import OpenInNewTabController from "./open_in_new_tab_controller"
application.register("open-in-new-tab", OpenInNewTabController)

import OptionalTimeToggleController from "./optional_time_toggle_controller"
application.register("optional-time-toggle", OptionalTimeToggleController)

import OverflowingController from "./overflowing_controller"
application.register("overflowing", OverflowingController)

import PermanentInputController from "./permanent_input_controller"
application.register("permanent-input", PermanentInputController)

import PostDraftController from "./post_draft_controller"
application.register("post-draft", PostDraftController)

import PostVisibilityController from "./post_visibility_controller"
application.register("post-visibility", PostVisibilityController)

import PrintPreviewController from "./print_preview_controller"
application.register("print-preview", PrintPreviewController)

import QuillEditorController from "./quill_editor_controller"
application.register("quill-editor", QuillEditorController)

import RestrictableHeightController from "./restrictable_height_controller"
application.register("restrictable-height", RestrictableHeightController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RibbonController from "./ribbon_controller"
application.register("ribbon", RibbonController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import SearchFiltersController from "./search_filters_controller"
application.register("search-filters", SearchFiltersController)

import SegmentTrackableController from "./segment_trackable_controller"
application.register("segment-trackable", SegmentTrackableController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import Select2TokenfieldController from "./select2_tokenfield_controller"
application.register("select2-tokenfield", Select2TokenfieldController)

import SessionHeartbeatController from "./session_heartbeat_controller"
application.register("session-heartbeat", SessionHeartbeatController)

import SetTimezoneController from "./set_timezone_controller"
application.register("set-timezone", SetTimezoneController)

import ShareableTextController from "./shareable_text_controller"
application.register("shareable-text", ShareableTextController)

import Sidebar__CollapseSectionController from "./sidebar/collapse_section_controller"
application.register("sidebar--collapse-section", Sidebar__CollapseSectionController)

import Sidebar__MobileController from "./sidebar/mobile_controller"
application.register("sidebar--mobile", Sidebar__MobileController)

import Sidebar__ResizeController from "./sidebar/resize_controller"
application.register("sidebar--resize", Sidebar__ResizeController)

import SocialEmbeds__FacebookController from "./social_embeds/facebook_controller"
application.register("social-embeds--facebook", SocialEmbeds__FacebookController)

import SocialEmbeds__TwitterController from "./social_embeds/twitter_controller"
application.register("social-embeds--twitter", SocialEmbeds__TwitterController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StickyHeaderController from "./sticky_header_controller"
application.register("sticky-header", StickyHeaderController)

import SuggestableLogoController from "./suggestable_logo_controller"
application.register("suggestable-logo", SuggestableLogoController)

import ToastComponentController from "./toast_component_controller"
application.register("toast-component", ToastComponentController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TransitionTurboframeController from "./transition_turboframe_controller"
application.register("transition-turboframe", TransitionTurboframeController)

import VerticalTickerController from "./vertical_ticker_controller"
application.register("vertical-ticker", VerticalTickerController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
